import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CustomCursor from "./page_assets/CustomCursor";
import Header from "./page_assets/header";
import Footer from "./page_assets/Footer";
import PageTransition from "./page_assets/PageTransition";
import ScrollToTopButton from "./page_assets/ScrollToTopButton";
import Home from "./pages/Home";
import CSPortfolio from "./pages/CSPortfolio";
import ArtPortfolio from "./pages/ArtPortfolio";

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-800 flex flex-col">
        {/* Above the routes on purpose: it survives navigation, so the pointer
            doesn't blink back to the system arrow between pages. */}
        <CustomCursor />
        <Header />
        <main className="flex-grow">
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cs-portfolio" element={<CSPortfolio />} />
              <Route path="/art-portfolio" element={<ArtPortfolio />} />
            </Routes>
          </PageTransition>
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}